import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private authService: AuthService) {}

    canActivate(): boolean {
        const token = localStorage.getItem('auth_token');
        if (token) {
            return true;
        } else {
            this.router.navigate(['/public']);
            return false;
        }
    }
}
